import axios from "axios";
import { getLocalStorage } from "./Stdata";
import { toast } from "react-toastify";

// const BASE_URL = "https://skillagig.qcodesinfotech.com/api/";
const BASE_URL = "https://api.skillagig.com/api/";
// const BASE_URL = "http://localhost:8003/api/";
// export const MediaUrl = `https://skillagig.qcodesinfotech.com/`;
export const MediaUrl = `https://api.skillagig.com/`;
// export const MediaUrl = `http://localhost:8003/`;

export const apiClient = axios.create({
  baseURL: BASE_URL,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

apiClient.interceptors.request.use(
  (config) => {
    const authData = getLocalStorage("AuthUser");
    const token = authData?.token || authData?.accessToken;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor with Token Refresh Logic
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    // Check if it's a 401/403 error and not already a retry or refresh call
    if (
      (status === 401 || status === 403) &&
      !originalRequest._retry &&
      !originalRequest.url.includes('refresh-token') &&
      !originalRequest.url.includes('login')
    ) {

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return apiClient(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const authData = getLocalStorage("AuthUser");
      const refreshToken = authData?.refreshToken || authData?.data?.refreshToken;

      if (!refreshToken) {
        logoutUser();
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(`${BASE_URL}auth/refresh-token`, { refreshToken });
        const newToken = response?.data?.accessToken || response?.data?.token || response?.data?.data?.token;
        const newRefreshToken = response?.data?.refreshToken || response?.data?.data?.refreshToken;

        if (newToken) {
          // Update tokens in storage
          const updatedAuthData = { ...authData };
          updatedAuthData.token = newToken;
          updatedAuthData.accessToken = newToken;
          if (newRefreshToken) updatedAuthData.refreshToken = newRefreshToken;

          sessionStorage.setItem("AuthUser", JSON.stringify(updatedAuthData));
          sessionStorage.setItem("token", newToken);

          processQueue(null, newToken);
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          return apiClient(originalRequest);
        } else {
          throw new Error("New token not received");
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        logoutUser();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

const logoutUser = () => {
  sessionStorage.clear();
  toast.error("Your session has expired. Please log in again.");
  setTimeout(() => {
    window.location.href = "/";
  }, 1000);
};

export const RefreshToken = (data) => apiClient.post(`auth/refresh-token`, data);


export const LoginUser = (data) => apiClient.post(`login`, data);
// industry
export const Add_industry = (data) => apiClient.post(`create-industry`, data);
export const List_industry = (data) => apiClient.get(`get-all-industries`, data);
export const Delete_industry = (id) => apiClient.delete(`delete-industry/${id}`);
export const Update_industry = (id, data) => apiClient.put(`update-industry/${id}`, data);
//skill
export const Add_skill = (data) => apiClient.post(`create-skill`, data);
export const List_skill = (data) => apiClient.get(`list-skill`, data);
export const Update_skill = (id, data) => apiClient.put(`update-skill/${id}`, data);
export const Delete_skill = (id) => apiClient.delete(`delete-skill/${id}`);

//gigs
export const List_gigs = () => apiClient.get(`list-gigs`);
export const Admin_GetGigFullDetails = (gigId) => apiClient.get(`admin/gig-full-details/${gigId}`);
//skill
export const Add_company = (data) => apiClient.post(`create-company`, data);
export const List_company = (data) => apiClient.get(`list-company`, data);

//country
export const Add_country = (data) => apiClient.post(`create-country`, data);
export const List_country = (data) => apiClient.get(`list-country`, data);

//platform fee
export const Add_platform_fee = (data) => apiClient.post(`create-platform-fee`, data);
export const List_platform_fee = (data) => apiClient.get(`get-platform-fee`);
export const Update_platform_fee = (id, data) => apiClient.put(`update-platform-fee/${id}`, data);
export const Delete_platform_fee = (id) => apiClient.delete(`delete-platform-fee/${id}`);

//document
export const Add_document = (data) => apiClient.post(`create-document`, data);
export const List_document = (data) => apiClient.get(`list-document`);
export const Update_document = (id, data) => apiClient.put(`update-document/${id}`, data);
export const Delete_document = (id) => apiClient.delete(`delete-document/${id}`);

// User API functions
export const Add_user = (data) => apiClient.post(`admin-create-user`, data);
export const List_user = (params) => apiClient.get(`admin/users`, { params });
export const Update_user = (id, data) => apiClient.put(`admin-update-user/${id}`, data);
export const Delete_user = (id, type = 'soft') => apiClient.delete(`admin-delete-user/${id}?type=${type}`);
export const Update_user_status = (id, data) => apiClient.put(`admin/users/${id}/status`, data);
export const Admin_refund_user = (id, data) => apiClient.post(`admin/users/${id}/refund`, data);


// City API (you'll need this for the user form)
export const List_city = (countryId) => apiClient.get(`get-cities/${countryId}`);

// Dashboard
export const Dashboard_data = (params) => apiClient.get(`admin/dashboard`, { params });
export const Platform_earnings = (params) => apiClient.get(`admin/platform-fees`, { params });

// Dispute Management
export const List_dispute = (params) => apiClient.get(`admin/disputes`, { params });
export const Get_dispute_details = (id) => apiClient.get(`disputes/${id}`); // Using common endpoint or admin specific if needed (common works as admin has access)
export const Resolve_dispute = (id, data) => apiClient.put(`admin/disputes/${id}/resolve`, data);
